//#region src/constants.ts
/**
* @namespace constants
*/
const headerNames = {
	authorization: "Authorization",
	contentType: "content-type",
	ocpApimSubscriptionKey: "ocp-apim-subscription-key"
};
const constants = { headers: { ...headerNames } };
const EXTERNAL_IDENTIFIER_SYSTEM = "https://prescryptive.io/externalidentifier";
const MEMBER_IDENTIFIER_SYSTEM = "https://prescryptive.io/memberidentifier";
const SMART_PRICE_PLAN_ID = "200P32F";
const SYSTEM_DRX_ID = "https://prescryptive.io/drxid";
const SYSTEM_NDC = "https://hl7.org/fhir/sid/ndc";
const SYSTEM_PRESCRIPTION_CATEGORY = "https://prescryptive.io/prescription-category";
const SYSTEM_PRESCRYPTIVE_PRESCRIBER_DRUG_DESCRIPTION = "https://prescryptive.io/prescriber-drug-description";
const SYSTEM_PRESCRIBER_DRUG_DESCRIPTION = "https://terminology.hl7.org/CodeSystem/prescriber-drug-description";
const SYSTEM_PRESCRIPTION_NUMBER = "https://prescryptive.com/CodeSystem/prescription-rxnumber";
const SMART_PRICE_CODES = new Set([
	SMART_PRICE_PLAN_ID,
	"CASH01",
	"SMP01"
]);
const SYSTEM_PRESCRIPTION_TARGET = "https://prescryptive.io/prescription-target";
const SYSTEM_SUBSTITUTED_NDC = "https://prescryptive.io/substituted-ndc";
const SYSTEM_SUBSTITUTED_NDC_QUANTITY = "https://prescryptive.io/substituted-ndc-quantity";
const SYSTEM_PERFORMER_ASSIGNMENT_TIMESTAMP = "https://prescryptive.io/performerassignmenttimestamp";
const SYSTEM_NCPDP_PROVIDER_ID = "http://terminology.hl7.org/CodeSystem/NCPDPProviderIdentificationNumber";
const SYSTEM_RENEWAL_STATUS = "https://prescryptive.io/renewal-status";
const SYSTEM_RENEWED_FROM_ORDER = "https://prescryptive.io/renewed-from-order";
const SYSTEM_CANCELLED_TIMESTAMP = "https://prescryptive.io/cancelled-timestamp";
const SYSTEM_RENEWAL_TIMESTAMP = "https://prescryptive.io/rxrenewalres-timestamp";
const SYSTEM_RENEWAL_REQUEST = "https://prescryptive.io/rxrenewalreq";
const SYSTEM_LAST_CHANGE_REQUESTED_NDC = "https://prescryptive.io/last-change-requested-ndc";
const SYSTEM_LAST_CHANGE_REQUESTED_REASON = "https://prescryptive.io/last-change-requested-reason";

//#endregion
export { EXTERNAL_IDENTIFIER_SYSTEM, MEMBER_IDENTIFIER_SYSTEM, SMART_PRICE_CODES, SMART_PRICE_PLAN_ID, SYSTEM_CANCELLED_TIMESTAMP, SYSTEM_DRX_ID, SYSTEM_LAST_CHANGE_REQUESTED_NDC, SYSTEM_LAST_CHANGE_REQUESTED_REASON, SYSTEM_NCPDP_PROVIDER_ID, SYSTEM_NDC, SYSTEM_PERFORMER_ASSIGNMENT_TIMESTAMP, SYSTEM_PRESCRIBER_DRUG_DESCRIPTION, SYSTEM_PRESCRIPTION_CATEGORY, SYSTEM_PRESCRIPTION_NUMBER, SYSTEM_PRESCRIPTION_TARGET, SYSTEM_PRESCRYPTIVE_PRESCRIBER_DRUG_DESCRIPTION, SYSTEM_RENEWAL_REQUEST, SYSTEM_RENEWAL_STATUS, SYSTEM_RENEWAL_TIMESTAMP, SYSTEM_RENEWED_FROM_ORDER, SYSTEM_SUBSTITUTED_NDC, SYSTEM_SUBSTITUTED_NDC_QUANTITY, constants, headerNames };